import type { DepartmentFragment } from "@/graphql";
import type { IMultiSelectItem, IOption } from "@/interfaces";

const toMultiSelectItem = (item: DepartmentFragment): IMultiSelectItem => {
  return {
    id: item.id,
    title: item.name,
    svg: "fas-house",
    iconBackground: item.color || undefined,
    svgStyle: "circle",
  };
};

const toOption = (item: DepartmentFragment): IOption => {
  return {
    value: item.id,
    title: item.name,
    svg: "fas-house",
    svgColor: item.color || undefined,
  };
};

export default {
  toMultiSelectItem,
  toOption,
};
